/* Default Colors */
/* CI/CD Colors */
/* 2021 TS Colors */
/* Scrollbars */
*:focus {
	outline: var(--oebb-outline, 2px dotted var(--oebb-accent-color, #e2002a));
	outline-offset: var(--oebb-outline-offset, 2px);
}

*:focus:not(:focus-visible) {
	outline: none;
}

*:focus-visible {
	outline: var(--oebb-outline, 2px dotted var(--oebb-accent-color, #e2002a));
	outline-offset: var(--oebb-outline-offset, 2px);
}

.hidden {
	display: none;
}

.invisible {
	visibility: hidden;
}

.offscreen {
	position: absolute;
	left: -1000em;
}

.screen-reader-text {
	position: absolute;

	width: 1px;
	height: 1px;
	margin: -1px;
	padding: 0;
	overflow: hidden;

	border: 0;
	clip-path: inset(50%);

	white-space: nowrap;
}

.screen-reader-text--focusable:active,
.screen-reader-text--focusable:focus {
	position: relative;

	width: auto;
	height: auto;
	margin: 0;
	overflow: visible;

	clip-path: none;

	white-space: inherit;
}

/** @deprecated */
/** ".is-tabbing" should be added via JavaScript and shows the outline. Used with class to not show outline on clicking elements. */
.is-tabbing button::-moz-focus-inner,
:host(.is-tabbing) button::-moz-focus-inner {
	border: 0;
}

.is-tabbing--focus,
.is-tabbing a:focus,
.is-tabbing button:focus,
.is-tabbing div:focus,
.is-tabbing input:focus,
.is-tabbing input:focus ~ span[role="presentation"],
:host(.is-tabbing) a:focus,
:host(.is-tabbing) button:focus,
:host(.is-tabbing) div:focus,
:host(.is-tabbing) input:focus,
:host(.is-tabbing) input:focus ~ span[role="presentation"] {
	outline: 2px dotted #e2002a;
	outline-offset: 2px;
	z-index: 10;
}

button {
  font-size: inherit;
}

.calendar-header {
  display: flex;
  align-items: center;
  height: 5rem;
}
.calendar-header h3 {
  flex: 1 0 auto;
  margin: 0;
  padding-left: 0.65rem;
  font-size: 1rem;
  font-weight: bold;
}
.calendar-header button {
  width: 2.5rem;
  background: none;
  border: none;
  cursor: pointer;
  fill: #2d3237;
}
.calendar-header button svg {
  display: inline-block;
  vertical-align: baseline;
  width: 1rem;
  height: 1rem;
  margin-top: 0.125rem;
}
.calendar-header button:disabled {
  cursor: not-allowed;
  fill: #babdc0;
}
.calendar-header .calendar__close-btn {
  position: absolute;
  top: -0.5rem;
  right: 1.25rem;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 1.875rem;
  height: 1.875rem;
  background-color: #ffffff;
  border-radius: 50%;
  opacity: 0;
}
.calendar-header .calendar__close-btn:focus {
  opacity: 1;
}

.header {
  display: grid;
  grid-template-columns: repeat(7, 1fr);
  grid-gap: 0.5rem;
  margin: 0 -0.5rem;
  padding: 0 0.75rem 0.35rem;
  list-style: none;
  color: #64696e;
  font-size: 0.875rem;
  text-align: center;
  border-bottom: 1px solid currentColor;
}

.days {
  display: grid;
  grid-template-columns: repeat(7, 1fr);
  grid-gap: 0.5rem;
  margin: 0.2rem 0 0;
  padding: 0.25rem;
  list-style: none;
}
.days li {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 2rem;
  border: 0;
  margin: 0;
  padding: 0;
  text-align: center;
}
.days li button {
  position: relative;
  display: block;
  margin: 0;
  padding: 0;
  width: 100%;
  height: 100%;
  background: none;
  border: none;
  border-radius: 50%;
  cursor: pointer;
  color: #64696e;
  font-size: 0.875rem;
}
.days li button:hover, .days li button.focused {
  background-color: #dce1e6;
}
.days li button.today::before {
  position: absolute;
  top: 50%;
  left: 50%;
  content: "";
  display: block;
  width: calc(100% + 0.125rem);
  height: calc(100% + 0.125rem);
  border: 1px solid #878c91;
  border-radius: 50%;
  transform: translate(-50%, -50%);
}
.days li button.active {
  background-color: #e2002a;
  color: #ffffff;
}
.days li button.active.today::before {
  border-color: #e2002a;
}
.days li.dow-1 {
  grid-column: 1;
}
.days li.dow-2 {
  grid-column: 2;
}
.days li.dow-3 {
  grid-column: 3;
}
.days li.dow-4 {
  grid-column: 4;
}
.days li.dow-5 {
  grid-column: 5;
}
.days li.dow-6 {
  grid-column: 6;
}
.days li.dow-0 {
  grid-column: 7;
}
.days li.disabled button {
  cursor: not-allowed;
  color: #babdc0;
}
.days li.disabled button:not(.focused):hover {
  background-color: transparent;
}

.calendar-footer {
  display: none;
}

:host {
  position: absolute;
  top: 100%;
  left: 0;
  z-index: 10;
  display: none;
  transform: translateY(var(--form-input-outline-width));
}

.calendar {
  z-index: 10;
  background: var(--form-input-bg);
  border: 1px solid var(--form-input-border-color);
  border-radius: var(--form-input-border-radius);
  box-shadow: 0 10px 20px rgba(var(--form-input-border-color), 0.2);
  width: calc(18.5rem + 2px);
  padding: 0 0.5rem 0.25rem;
  box-sizing: border-box;
}
.calendar .calendar-header button {
  fill: var(--form-calendar-button-color);
}
.calendar .calendar-header button:disabled {
  fill: var(--form-calendar-disabled-color);
}
.calendar .calendar-header .calendar__close-btn {
  background-color: var(--form-calendar-button-bg);
}
.calendar .header {
  color: var(--form-calendar-color);
}
.calendar .days li button {
  color: var(--form-calendar-color);
}
.calendar .days li button:hover, .calendar .days li button.focused {
  background-color: var(--form-calendar-day-hover);
}
.calendar .days li button.today::before {
  border-color: var(--form-calendar-today-border);
}
.calendar .days li button.active {
  background-color: var(--form-calendar-active-bg);
  color: var(--form-calendar-active-color);
}
.calendar .days li button.active.today::before {
  border-color: var(--form-calendar-active-bg);
}
.calendar .days li.disabled button {
  color: var(--form-calendar-disabled-color);
}